import { Card } from "@/components/ui/card";

export default function KpiCard({ label, value, suffix, icon: Icon, accent, testId }) {
  return (
    <Card
      data-testid={testId}
      className="p-5 border-slate-200 shadow-none hover:shadow-sm hover:-translate-y-0.5 transition-all bg-white"
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs font-bold tracking-[0.15em] uppercase text-slate-400">{label}</div>
          <div className="mt-2 font-heading text-3xl font-bold text-slate-900 tracking-tight">
            {value}
            {suffix && <span className="text-base font-semibold text-slate-400 ml-1">{suffix}</span>}
          </div>
        </div>
        {Icon && (
          <div
            className="h-10 w-10 rounded-xl flex items-center justify-center"
            style={{ background: accent ? "var(--brand-muted, rgba(14,165,233,.1))" : "#F1F5F9" }}
          >
            <Icon className="h-5 w-5" style={{ color: accent ? "var(--brand)" : "#64748B" }} />
          </div>
        )}
      </div>
    </Card>
  );
}
